import {
	HomeIcon
} from '@heroicons/vue/24/outline'
import {
	Nav
} from '@/types'

export const nav: Nav = { 
    name: 'Dashboard', 
    to: {name: 'Dashboard'}, 
    icon: HomeIcon, 
    position: 0,
    show: true,
	module: "dashboard"
}
